/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseKingDifferenceBlockFragment, KingDifferenceBlockFragment, FullKingDifferenceBlockFragment} from '@amblique/contentful/app/contentful/fragments/king-difference-block';

/**
 * Get a single KingDifferenceBlock by ID (base - scalars only)
 */
export const getBaseKingDifferenceBlockById = gql`
  ${BaseKingDifferenceBlockFragment}

  query GetBaseKingDifferenceBlockById($id: String!, $locale: String!, $preview: Boolean) {
    kingDifferenceBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseKingDifferenceBlockFragment
    }
  }
`;

/**
 * Get a single KingDifferenceBlock by ID (standard - 1 level deep)
 */
export const getKingDifferenceBlockById = gql`
  ${KingDifferenceBlockFragment}

  query GetKingDifferenceBlockById($id: String!, $locale: String!, $preview: Boolean) {
    kingDifferenceBlock(id: $id, locale: $locale, preview: $preview) {
      ...KingDifferenceBlockFragment
    }
  }
`;

/**
 * Get a single KingDifferenceBlock by ID (full - 2 levels deep)
 */
export const getFullKingDifferenceBlockById = gql`
  ${FullKingDifferenceBlockFragment}

  query GetFullKingDifferenceBlockById($id: String!, $locale: String!, $preview: Boolean) {
    kingDifferenceBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullKingDifferenceBlockFragment
    }
  }
`;

/**
 * Get all KingDifferenceBlock entries with pagination (base - scalars only)
 */
export const getBaseKingDifferenceBlocks = gql`
  ${BaseKingDifferenceBlockFragment}

  query GetBaseKingDifferenceBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [KingDifferenceBlockOrder]
    $where: KingDifferenceBlockFilter
    $preview: Boolean
  ) {
    kingDifferenceBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseKingDifferenceBlockFragment
      }
    }
  }
`;

/**
 * Get all KingDifferenceBlock entries with pagination (standard - 1 level deep)
 */
export const getKingDifferenceBlocks = gql`
  ${KingDifferenceBlockFragment}

  query GetKingDifferenceBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [KingDifferenceBlockOrder]
    $where: KingDifferenceBlockFilter
    $preview: Boolean
  ) {
    kingDifferenceBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...KingDifferenceBlockFragment
      }
    }
  }
`;

/**
 * Get all KingDifferenceBlock entries with pagination (full - 2 levels deep)
 */
export const getFullKingDifferenceBlocks = gql`
  ${FullKingDifferenceBlockFragment}

  query GetFullKingDifferenceBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [KingDifferenceBlockOrder]
    $where: KingDifferenceBlockFilter
    $preview: Boolean
  ) {
    kingDifferenceBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullKingDifferenceBlockFragment
      }
    }
  }
`;
